import { FETCH_METHODS, SearchConfig } from "./api.model";
import { ChartTypes, CommonChartModel } from "./chart.model";
import { DataTableSchema } from "./dynamic-data-table.model";

export const chatBotSearchConfig:SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: "chatbot"
}

export type chatbotTableSchema = {
    headers:any[],
    data:any[]
}

export type MessagesType = {
    question: string;
    answer: any;
    type?: 'text' | 'table' | 'chart' | 'img' | 'download'; 
    tableSchema?:DataTableSchema,
    chartConfig?:chatbotChartConfig,
    image?:any,
    showSuggestion: boolean;
    suggestedQuestions?: string[];
    suggestedQns?:any;
    downloadable?: boolean;
}

export type chatbotChartConfig = {
    chartSchema : CommonChartModel,
    filterSchema?: any,
    chartType: ChartTypes,
    elementId:any,
    onLoadFetch: boolean
    

}